import React from "react";
import { Link, useLocation } from "react-router-dom";
import { helpArticlePath, helpCategoryPath } from "../helpRoutes";

const CATEGORY_ICONS = {
  "Getting Started": "◎",
  Editor: "✦",
  Billing: "◇",
  Export: "↗",
  Troubleshooting: "!",
};

const categoryIcon = (name = "") => CATEGORY_ICONS[name] || "◎";

const Sidebar = ({
  helpPageData,
  tertiaryId,
  openSubheadingId,
  toggleSubheading,
  setSelectedHeading,
  setOpenSubheadingId,
  setHeadingClicked,
  setMainHeading,
  setTertiaryId,
  loadPageContent,
}) => {
  const { pathname } = useLocation();

  const handleHeadingClick = (heading) => {
    setSelectedHeading(heading);
    setMainHeading(heading.heading);
    setOpenSubheadingId(null);
    setHeadingClicked(true);
    setTertiaryId("");
  };

  const handleSubheadingClick = (event, heading, sub) => {
    event.preventDefault();
    if (loadPageContent) return;
    setSelectedHeading(heading);
    setMainHeading(heading.heading);
    setHeadingClicked(true);
    toggleSubheading(heading._id, sub._id);
  };

  return (
    <>
      <p className="sidebar-heading">Browse help</p>
      <nav aria-label="Help topics">
        {(helpPageData || []).map((heading) => (
          <section className="category" key={heading._id} aria-labelledby={`cat-${heading._id}`}>
            <h2 className="category-title" id={`cat-${heading._id}`}>
              <Link
                to={helpCategoryPath(heading.heading)}
                className="category-title-link"
                aria-current={pathname === helpCategoryPath(heading.heading) ? "page" : undefined}
                onClick={() => handleHeadingClick(heading)}
              >
                <span className="category-icon" aria-hidden="true">
                  {categoryIcon(heading.heading)}
                </span>
                {heading.heading}
              </Link>
            </h2>
            <ul className="nav-list">
              {(heading.subHeadings || []).map((sub) => {
                const subId = `${heading._id}-${sub._id}`;
                const isOpen = openSubheadingId === subId;
                const tertiaries = sub.tertiarySubHeadings || [];
                return (
                  <li key={sub._id}>
                    <button
                      className="nav-link nav-subheading"
                      type="button"
                      aria-expanded={isOpen}
                      onClick={(event) => handleSubheadingClick(event, heading, sub)}
                    >
                      <span>{sub.subHeading}</span>
                      <span className={`nav-caret${isOpen ? " is-open" : ""}`} aria-hidden="true">
                        ›
                      </span>
                    </button>
                    {isOpen ? (
                      <ul className="nav-tertiary-list">
                        {tertiaries.map((tertiary) => {
                          const path = helpArticlePath(
                            heading.heading,
                            sub.subHeading,
                            tertiary.tertiarySubHeading,
                            tertiary._id
                          );
                          const isActive = String(tertiaryId) === String(tertiary._id);
                          return (
                            <li key={tertiary._id}>
                              <Link
                                className="nav-link nav-tertiary"
                                to={path}
                                aria-current={isActive ? "page" : undefined}
                                onClick={() => {
                                  setSelectedHeading(heading);
                                  setHeadingClicked(false);
                                }}
                              >
                                {tertiary.tertiarySubHeading}
                              </Link>
                            </li>
                          );
                        })}
                      </ul>
                    ) : null}
                  </li>
                );
              })}
            </ul>
          </section>
        ))}
      </nav>
    </>
  );
};

export default Sidebar;
